// extracted by mini-css-extract-plugin
export var outgrowWrapper = "outgrow-module--outgrow-wrapper--cbe68";